import Vue from 'vue'
import Router from 'vue-router'
import navfds from '@/components/navfds/navfds'
//import home from '@/components/home'
//import example from '@/components/example'

Vue.use(Router)

export default new Router({
	mode: "history",
  base: '/fds_web/',
  routes: [
    {
      path: '/',
      name: 'navfds',
      component: navfds
    }
  ],
   
})



// WEBPACK FOOTER //
// ./src/router/index.js